module.exports = __webpack_public_path__ + "static/media/flag-german.5646124e.jpg";